import React from 'react';
import WorkshopRow from './WorkshopRow';
import EmptyWorkshop from './EmptyWorkshop';
import LikedWorkshopsList from '../LikedWorkshops/LikedWorkshopsList';

const MyWorkshopsList = ({
  currentFilter,
  workshopsList = [],
  likedWorkshopsList = [],
  onLikeDeleteSuccess,
  onExpire,
  onCancelClick,
}) => {
  if (currentFilter === 'Saved') {
    if (likedWorkshopsList.length === 0) {
      return (
        <div className='w-full flex flex-col overflow-hidden'>
          <div className='flex flex-col gap-3 tabletH:min-h-[400px]'>
            <EmptyWorkshop />
          </div>
        </div>
      );
    }

    return (
      <div className='w-full flex flex-col overflow-hidden'>
        <div className='flex flex-col gap-3'>
          <LikedWorkshopsList
            likedWorkshopsList={likedWorkshopsList}
            onLikeDeleteSuccess={onLikeDeleteSuccess}
            isLimit={false}
          />
        </div>
      </div>
    );
  }

  if (workshopsList.length === 0) {
    return (
      <div className='w-full flex flex-col overflow-hidden'>
        <div className='tabletH:pb-10 flex flex-col gap-3 tabletH:min-h-[400px]'>
          <EmptyWorkshop />
        </div>
      </div>
    );
  }

  const displayList = [...workshopsList];

  return (
    <div className='w-full max-w-[868px] flex flex-col overflow-hidden'>
      <div className='pb-10 flex flex-col gap-3'>
        {displayList.map((item) => (
          <WorkshopRow
            key={item.bookingId}
            item={item}
            onExpire={onExpire}
            onCancelClick={onCancelClick}
          />
        ))}
      </div>
    </div>
  );
};

export default MyWorkshopsList;
